<button mat-flat-button class="return-btn">
  <mat-icon>chevron_left</mat-icon>
  {{ label | translate }}
</button>
